import { useTranslation } from "react-i18next";
import { WebProductCard } from "./WebProductCard";
import { ProductShowcase } from "./product-showcase";
import type { WebSearchProduct } from "@/api/models/api-types";

export interface WebProductCarouselWidgetProps {
  className?: string;
  products: WebSearchProduct[];
  query?: string;
}

/** Katalog dışı (web araması) ürünler — aynı vitrin, dış bağlantılı kart. */
export const WebProductCarouselWidget: React.FC<
  WebProductCarouselWidgetProps
> = ({ className, products, query }) => {
  const { t } = useTranslation();

  if (!products || products.length === 0) {
    return null;
  }

  return (
    <ProductShowcase
      className={className}
      items={products}
      getKey={(product, index) => product.externalId || `web-product-${index}`}
      renderItem={(product) => <WebProductCard product={product} />}
      title={
        <>
          {t("chat.webProducts.externalProducts")}
          {query ? (
            <span className="text-text-tertiary dark:text-gray-500">
              {" "}
              · {query}
            </span>
          ) : null}
        </>
      }
    />
  );
};
